export default __webpack_public_path__ + "static/media/GraphicsIconW.73cb82e6.svg";